export default "__VITE_PUBLIC_ASSET__170c322e__"